import { useAtomValue } from "jotai";
import { useEffect, useRef } from "react";
import { useInitTwilioChatClient } from "../../session/chat/useInitTwilioChatClient";
import { isChatReadyAtom } from "../../session/state";
import { roomTokenAtom } from "../../video-sdk";
import { useConversationCallbacks } from "../chat";
import { activeConversationSidAtom } from "../state";

export function useSessionConversation() {
  useInitTwilioChatClient({
    twilioChatToken: useAtomValue(roomTokenAtom),
  });
  const joinedConversationSidRef = useRef<string>();
  const isChatReady = useAtomValue(isChatReadyAtom);
  const conversationId = useAtomValue(activeConversationSidAtom);
  const { joinConversation, leaveConversation } = useConversationCallbacks();

  useEffect(
    function handleSessionConversation() {
      const hasValidClientAndConvo = isChatReady && conversationId;
      const isAlreadyInSessionChat =
        joinedConversationSidRef.current === conversationId;
      if (!hasValidClientAndConvo || isAlreadyInSessionChat) return;

      joinConversation(conversationId);
      joinedConversationSidRef.current = conversationId;

      return function cleanup() {
        if (!hasValidClientAndConvo || !isAlreadyInSessionChat) return;

        leaveConversation(conversationId);
        joinedConversationSidRef.current = undefined;
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isChatReady, conversationId],
  );
}
